"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionBodyRegistryWidget = exports.AccordionBodyWidget = void 0;
var Expander_1 = require("ContentTokens/SharedWidgetComponents/Expander");
var mobx_react_1 = require("mobx-react");
var PlaceholderContext_1 = __importDefault(require("Project/QwilrEditor/Placeholder/PlaceholderContext"));
var react_1 = __importStar(require("react"));
var AccordionContext_1 = require("./AccordionContext");
var styles = __importStar(require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css"));
var classnames_1 = __importDefault(require("classnames"));
var styleUtilities_1 = require("ContentTokens/SharedWidgetComponents/Accordion/styleUtilities");
var pages_common_1 = require("@qwilr/pages-common");
var StylesContext_1 = require("Project/QwilrEditor/StylesContext");
var dynamic_1 = require("@vanilla-extract/dynamic");
var accordion_css_1 = require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css");
var AccordionBodyWidgetComponent = (function (_super) {
    __extends(AccordionBodyWidgetComponent, _super);
    function AccordionBodyWidgetComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionBodyWidgetComponent.prototype.render = function () {
        var _a;
        var _b = this.props, attributes = _b.attributes, _c = _b.context, expanded = _c.expanded, style = _c.style, children = _b.children;
        var bodyColor = (0, styleUtilities_1.calculateBodyColor)(style);
        return (react_1.default.createElement("div", __assign({}, attributes),
            react_1.default.createElement(Expander_1.Expander, { open: expanded },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("accordion-widget-body", styles.accordionBody({
                        buttonPosition: (0, styleUtilities_1.calculateButtonPosition)(style),
                        type: style.cardStyle === "visual" ? "visual" : style.headerBackground.on ? "simple" : "transparent",
                    })), style: __assign({}, (bodyColor &&
                        (0, dynamic_1.assignInlineVars)((_a = {},
                            _a[accordion_css_1.computedVars.bodyBackground] = bodyColor,
                            _a)))), "data-layout-node": "true" },
                    react_1.default.createElement(PlaceholderContext_1.default, { placeholders: {
                            paragraph: function (_a) {
                                var isFocussed = _a.isFocussed, isOnlyChild = _a.isOnlyChild;
                                if (!isFocussed && isOnlyChild) {
                                    return "Add content";
                                }
                                if (isFocussed) {
                                    var isMac = /mac/i.test(navigator.platform);
                                    var cmdOrCtrl = isMac ? "Cmd" : "Ctrl";
                                    return "Add content, or press  ".concat(cmdOrCtrl, " + Enter for a new item");
                                }
                                return;
                            },
                        } },
                        react_1.default.createElement(StylesContext_1.LayoutStylesContextProvider, { backgroundColor: bodyColor, computeForegroundColor: function (preferredForegroundColor) {
                                if (!bodyColor) {
                                    return preferredForegroundColor;
                                }
                                return (0, pages_common_1.goldilocks)(bodyColor, { mode: "text", foregroundColor: preferredForegroundColor });
                            } }, children))))));
    };
    AccordionBodyWidgetComponent = __decorate([
        mobx_react_1.observer
    ], AccordionBodyWidgetComponent);
    return AccordionBodyWidgetComponent;
}(react_1.default.Component));
exports.AccordionBodyWidget = (0, AccordionContext_1.withAccordionContext)(AccordionBodyWidgetComponent);
var AccordionBodyRegistryWidget = function (_a) {
    var children = _a.children;
    var accordionBodyRef = (0, react_1.useRef)(undefined);
    return (react_1.default.createElement(exports.AccordionBodyWidget, { attributes: { ref: accordionBodyRef }, isSelected: false }, children));
};
exports.AccordionBodyRegistryWidget = AccordionBodyRegistryWidget;
